// extracted by mini-css-extract-plugin
module.exports = {"title":"SaleSmallDetails_title__G5GJv","btn-certificate":"SaleSmallDetails_btn-certificate__iS7ri"};